export const en = {
  'common.back': 'Back',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.cancel': 'Cancel',
  'common.ok': 'OK',
  'common.confirm': 'Confirm',
  'common.confirmTitle': 'Please confirm',
  'common.alertTitle': 'Notice',
  'common.errorTitle': 'Error',
  'common.save': 'Save',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.loading': 'Loading...',
  'common.retry': 'Retry',
  'common.unavailable': 'Unavailable',
  'common.name': 'Name',
  'common.slug': 'Slug',
  'common.status': 'Status',
  'common.parent': 'Parent',
  'common.type': 'Type',
  'common.system': 'System',
  'common.noneRoot': 'None (root)',
  'common.language': 'Language',
  'common.english': 'English',
  'common.spanish': 'Spanish',
  'login.eyebrow': 'Scent for every space.',
  'login.hero': 'Admin panel for Diffuser Dreams catalog, brands, categories, and orders.',
  'login.signIn': 'Sign in to Admin',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.submit': 'Login',
  'login.error': 'Invalid email or password.',
  'passwordReset.forgotLink': 'Forgot password?',
  'passwordReset.forgotTitle': 'Reset password',
  'passwordReset.forgotHero': 'Enter your email and we will send you a reset link.',
  'passwordReset.forgotHint': 'We will email a link to reset your password if an account exists.',
  'passwordReset.sendLink': 'Send reset link',
  'passwordReset.sent': 'If an account exists for that email, a reset link has been sent.',
  'passwordReset.backToLogin': 'Back to sign in',
  'passwordReset.requestError': 'Could not send reset email. Try again later.',
  'passwordReset.resetTitle': 'Choose a new password',
  'passwordReset.resetHero': 'Set a new password for your admin account.',
  'passwordReset.newPassword': 'New password',
  'passwordReset.confirmPassword': 'Confirm password',
  'passwordReset.savePassword': 'Save password',
  'passwordReset.done': 'Password updated. You can sign in now.',
  'passwordReset.resetError': 'Invalid or expired reset link.',
  'passwordReset.invalidLink': 'This reset link is invalid. Request a new one.',
  'passwordReset.requestNewLink': 'Request a new link',
  'passwordReset.emailRequired': 'Email is required.',
  'passwordReset.emailInvalid': 'Enter a valid email address.',
  'passwordReset.passwordRequired': 'Password is required.',
  'passwordReset.passwordMin': 'Password must be at least 8 characters.',
  'passwordReset.confirmRequired': 'Confirm your password.',
  'passwordReset.passwordMismatch': 'Passwords do not match.',
  'admin.panel': 'Admin Panel',
  'admin.logout': 'Sign out',
  'admin.impersonating': 'Viewing as',
  'admin.exitImpersonation': 'Exit impersonation',
  'admin.viewStorefront': 'View storefront',
  'admin.business': 'Business',
  'admin.nav.dashboard': 'Dashboard',
  'admin.nav.users': 'Users',
  'admin.nav.orders': 'Orders',
  'admin.nav.products': 'Products',
  'admin.nav.bundles': 'Bundles',
  'admin.nav.brands': 'Brands',
  'admin.nav.categories': 'Categories',
  'admin.nav.categoryFilters': 'Category Filters',
  'admin.nav.categorySpecs': 'Spec Tags',
  'admin.nav.chat': 'Chat',
  'admin.nav.settings': 'Settings',
  'admin.nav.aiMarketing': 'AI Marketing',
  'settings.title': 'Business settings',
  'settings.subtitle': 'Features, payments, and email for the selected business. Switch business in the sidebar to edit another.',
  'settings.editingBusiness': 'Editing business',
  'settings.tab.features': 'Features',
  'settings.tab.brand': 'Brand',
  'settings.tab.stripe': 'Stripe',
  'settings.tab.email': 'Email',
  'settings.tab.facebook': 'Facebook',
  'settings.features.sectionDesc': 'Turn modules on or off for this business.',
  'settings.brand.sectionDesc': 'Display name used on order PDFs and confirmation emails.',
  'settings.stripe.sectionDesc': 'Checkout keys for this business only.',
  'settings.stripe.webhookSecretHint':
    'Filled automatically when you create a webhook below. You can also paste it manually from Stripe.',
  'settings.stripe.webhooksTitle': 'Stripe webhooks',
  'settings.stripe.webhooksDesc':
    'Lists endpoints on this business Stripe account. Create one with your public domain (CloudFront or custom) and delete old ones.',
  'settings.stripe.webhooksNeedSecret': 'Save the Stripe secret key first to manage webhooks.',
  'settings.stripe.webhookExpectedPath': 'Expected path',
  'settings.stripe.webhookBaseUrl': 'Public domain (base URL)',
  'settings.stripe.webhookBaseUrlRequired': 'Enter the domain base URL (https://…).',
  'settings.stripe.webhookCreate': 'Create webhook',
  'settings.stripe.webhookCreated': 'Webhook created and signing secret saved for this business.',
  'settings.stripe.webhookCreateError': 'Could not create the Stripe webhook.',
  'settings.stripe.webhookDeleteConfirm': 'Delete this webhook?\n{url}',
  'settings.stripe.webhookDeleteError': 'Could not delete the webhook.',
  'settings.stripe.webhooksLoadError': 'Could not load Stripe webhooks.',
  'settings.stripe.webhooksEmpty': 'No webhooks on this Stripe account.',
  'settings.stripe.webhookMatchesBusiness': 'This business',
  'settings.email.sectionDesc':
    'Resend From identity for this business. Domain must be verified in Resend.',
  'settings.features.liveChat': 'Live chat',
  'settings.features.liveChatDesc': 'Visitor widget and admin inbox for this business.',
  'settings.features.aiMarketing': 'AI Marketing',
  'settings.features.aiMarketingDesc': 'Connect Meta via OAuth, AI assistant insights, and future creatives/ads.',
  'aiMarketing.back': 'Back to AI Marketing',
  'aiMarketing.loadError': 'Could not load AI Marketing.',
  'aiMarketing.disconnectTitle': 'Disconnect Meta?',
  'aiMarketing.disconnectMessage': 'This removes the Meta connection for this business.',
  'aiMarketing.hub.subtitle': 'Creatives, paused Meta ads, organic posts, and the AI assistant — Meta connections are below when you need them.',
  'aiMarketing.hub.toolsCol': 'Tool',
  'aiMarketing.hub.descCol': 'Description',
  'aiMarketing.hub.open': 'Open',
  'aiMarketing.integrations.subtitle': 'Connect your Facebook Page, Instagram, and optional ad account in one Meta sign-in.',
  'aiMarketing.integrations.onePerBusiness': 'One Meta connection per business — reconnecting replaces the current Page and Instagram.',
  'aiMarketing.integrations.reconnect': 'Reconnect',
  'aiMarketing.integrations.channel': 'Channel',
  'aiMarketing.integrations.meta': 'Meta',
  'aiMarketing.integrations.metaHint': 'Sign in with Meta once. Facebook Page is required; Instagram and ad accounts are optional.',
  'aiMarketing.integrations.facebook': 'Facebook Page',
  'aiMarketing.integrations.instagram': 'Instagram',
  'aiMarketing.integrations.notConnected': 'Not connected',
  'aiMarketing.hub.creativesDesc': 'Upload your own image/video or use a catalog product.',
  'aiMarketing.hub.organicDesc': 'Published organic posts history (read-only).',
  'aiMarketing.hub.assistantDesc': 'Ask about organic reels and videos on your connected Meta accounts.',
  'aiMarketing.nav.assistant': 'AI Assistant',
  'aiMarketing.nav.creatives': 'Creatives',
  'aiMarketing.nav.organic': 'Organic',
  'aiMarketing.connection.notConnected': 'Meta is not connected for this business.',
  'aiMarketing.connection.needsSelection': 'Meta is authorized. Select a Page and Ad Account to finish.',
  'aiMarketing.connection.connectMeta': 'Sign in with Meta',
  'aiMarketing.connection.continue': 'Continue setup',
  'aiMarketing.connection.disconnect': 'Disconnect',
  'aiMarketing.connect.title': 'Connect Meta',
  'aiMarketing.connect.subtitleWizard': 'Sign in with Meta, then choose your Page, Instagram, and optional ad account.',
  'aiMarketing.connect.metaFlowDesc': 'Facebook Page is required. Enable Instagram or advertising only if you need them.',
  'aiMarketing.connect.navConfigure': 'What to connect',
  'aiMarketing.connect.navAccounts': 'Choose accounts',
  'aiMarketing.connect.intentTitle': 'What do you want to connect?',
  'aiMarketing.connect.intentFacebookPage': 'Facebook Page (required)',
  'aiMarketing.connect.intentInstagram': 'Instagram account',
  'aiMarketing.connect.instagramOnThisPage': 'Linked to this Page',
  'aiMarketing.connect.instagramOtherOnMeta': 'Other Instagram on Meta',
  'aiMarketing.connect.instagramNoneForPage': 'No Instagram found on Meta for this login. Connect Instagram separately if you need it.',
  'aiMarketing.connect.permissionsTitle': 'Permissions requested',
  'aiMarketing.connect.scope.pagesShowList': 'View your Facebook Pages',
  'aiMarketing.connect.scope.pagesReadEngagement': 'Read Page engagement and insights',
  'aiMarketing.connect.scope.pagesManagePosts': 'Create and manage posts on your Pages',
  'aiMarketing.connect.scope.businessManagement': 'Manage business assets',
  'aiMarketing.connect.scope.instagramBasic': 'View Instagram profile',
  'aiMarketing.connect.scope.instagramManageInsights': 'Read Instagram insights',
  'aiMarketing.connect.scope.instagramContentPublish': 'Publish content to Instagram',
  'aiMarketing.connect.noPages': 'We could not find a Facebook Page you manage. Create one, then refresh.',
  'aiMarketing.connect.overwriteTitle': 'Replace Instagram?',
  'aiMarketing.connect.overwriteMessage': 'This business already uses {username}. Only one Instagram is allowed — the new connection will replace it.',
  'aiMarketing.connect.overwritePageTitle': 'Replace Facebook Page?',
  'aiMarketing.connect.overwritePageMessage': 'This business already uses {name}. Only one Page is allowed — the new connection will replace it.',
  'aiMarketing.connect.createPage': 'Create Facebook Page',
  'aiMarketing.connect.refresh': 'Refresh',
  'aiMarketing.connect.page': 'Facebook Page',
  'aiMarketing.connect.instagram': 'Instagram',
  'aiMarketing.connect.instagramOptional': 'None (optional)',
  'aiMarketing.connect.selectRequired': 'Select a Facebook Page to continue. Ad Account is optional until Marketing API scopes are enabled.',
  'aiMarketing.assistant.subtitle':
    'Ask about organic reels and videos on your connected Facebook Page and Instagram.',
  'aiMarketing.assistant.empty':
    'Try asking which reel got the most views, or what was the latest upload.',
  'aiMarketing.assistant.placeholder': 'Ask anything about your Meta marketing...',
  'aiMarketing.assistant.launcher': 'AI Assistant',
  'aiMarketing.assistant.send': 'Send',
  'aiMarketing.assistant.platform': 'Platform',
  'aiMarketing.assistant.views': 'Views',
  'aiMarketing.assistant.reach': 'Reach',
  'aiMarketing.assistant.posted': 'Posted',
  'aiMarketing.assistant.content': 'Content',
  'aiMarketing.assistant.thinking': 'Thinking…',
  'aiMarketing.creatives.subtitle': 'Upload your own image/video or use a catalog product, then approve before use.',
  'aiMarketing.creatives.uploadTitle': 'Upload your asset',
  'aiMarketing.creatives.uploadHint': 'JPG/PNG/WebP up to 20MB, or MP4 up to 100MB.',
  'aiMarketing.creatives.upload': 'Upload',
  'aiMarketing.creatives.add': 'Add',
  'aiMarketing.creatives.addClose': 'Close',
  'aiMarketing.creatives.fromProductTitle': 'From catalog product',
  'aiMarketing.creatives.fromProductHint': 'Search a product and use its image as the creative - no file from your PC.',
  'aiMarketing.creatives.fromProductSearch': 'Search product',
  'aiMarketing.creatives.fromProductSearchPlaceholder': 'Name, SKU, or model...',
  'aiMarketing.creatives.fromProductCreate': 'Create creative',
  'aiMarketing.creatives.fromProductCancel': 'Choose another',
  'aiMarketing.creatives.publish': 'Publish',
  'aiMarketing.creatives.publishing': 'Publishing…',
  'aiMarketing.creatives.publishingTo': 'Publishing to {platform}…',
  'aiMarketing.creatives.publishingHint': 'This can take up to a minute, especially for videos.',
  'aiMarketing.creatives.publishCaption': 'Caption',
  'aiMarketing.creatives.publishCancel': 'Back',
  'aiMarketing.creatives.publishPlatformsEmpty':
    'No connected publish destinations. Connect Facebook or Instagram in AI Marketing integrations.',
  'aiMarketing.creatives.publishConfirmTitle': 'Publish creative?',
  'aiMarketing.creatives.publishConfirmMessage': 'Publish to: {destinations}.',
  'aiMarketing.creatives.publishPartialTitle': 'Some destinations failed',
  'aiMarketing.platform.Facebook': 'Facebook',
  'aiMarketing.platform.Instagram': 'Instagram',
  'aiMarketing.creatives.library': 'Library',
  'aiMarketing.creatives.empty': 'No creatives yet. Upload an asset or create one from a product.',
  'aiMarketing.creatives.allStatuses': 'All statuses',
  'aiMarketing.creatives.allTypes': 'All types',
  'aiMarketing.creatives.allSources': 'All sources',
  'aiMarketing.creatives.approve': 'Approve',
  'aiMarketing.creatives.deleteTitle': 'Delete creative?',
  'aiMarketing.creatives.deleteMessage':
    'This removes the creative permanently. Published posts stay in Organic history.',
  'aiMarketing.creatives.publishedOn': 'Published on',
  'aiMarketing.creatives.status.Generated': 'Generated',
  'aiMarketing.creatives.status.Approved': 'Approved',
  'aiMarketing.creatives.source.UserUpload': 'Upload',
  'aiMarketing.creatives.source.ProductCatalog': 'Product',
  'aiMarketing.creatives.type.Image': 'Image',
  'aiMarketing.creatives.type.Video': 'Video',
  'aiMarketing.organic.subtitle': 'Read-only history of organic posts published from creatives.',
  'aiMarketing.organic.viewPost': 'View post',
  'aiMarketing.organic.empty': 'No organic posts yet. Publish from Creatives.',
  'aiMarketing.organic.status.Draft': 'Draft',
  'aiMarketing.organic.status.Approved': 'Approved',
  'aiMarketing.organic.status.Published': 'Published',
  'aiMarketing.organic.status.Failed': 'Failed',
  'settings.brand.displayName': 'Display name',
  'settings.stripe.publishableKey': 'Publishable key',
  'settings.stripe.secretKey': 'Secret key',
  'settings.stripe.webhookSecret': 'Webhook secret',
  'settings.email.domain': 'Email domain',
  'settings.email.orderUserName': 'Orders username',
  'settings.email.orderFromName': 'Orders from name',
  'settings.email.passwordResetUserName': 'Password reset username',
  'settings.email.passwordResetFromName': 'Password reset from name',
  'settings.email.test': 'Send test email',
  'settings.email.testing': 'Sending…',
  'settings.email.testSent': 'Test email sent to {to} from {from}.',
  'settings.email.testError': 'Could not send the test email.',
  'settings.facebook.sectionDesc':
    'Meta app credentials for this business (Facebook Login and AI Marketing OAuth).',
  'settings.facebook.appId': 'Facebook App ID',
  'settings.facebook.appSecret': 'Facebook App secret',
  'settings.secretPlaceholder': 'Leave blank to keep current',
  'settings.saved': 'Settings saved.',
  'settings.loadError': 'Could not load business settings.',
  'settings.saveError': 'Could not save business settings.',
  'chat.send': 'Send',
  'chat.close': 'Close',
  'chat.mute': 'Mute sound',
  'chat.unmute': 'Unmute sound',
  'chat.visitor.launcher': 'Chat with us',
  'chat.visitor.title': 'Live chat',
  'chat.visitor.empty': 'Ask a question and our team will reply here.',
  'chat.visitor.greeting':
    'Hi! How can we help you today? Tell us what you need and our team will get back to you shortly.',
  'chat.visitor.placeholder': 'Type your message…',
  'chat.admin.subtitle': 'Visitor conversations for this business.',
  'chat.admin.empty': 'No conversations yet.',
  'chat.admin.pick': 'Select a conversation to reply.',
  'chat.admin.placeholder': 'Reply to visitor…',
  'chat.admin.noPreview': 'No messages yet',
  'chat.admin.notify': 'Chat notifications',
  'dashboard.subtitle': 'Quick access to catalog administration.',
  'dashboard.users.title': 'Users',
  'dashboard.users.desc': 'Create and manage admin accounts',
  'dashboard.settings.title': 'Settings',
  'dashboard.settings.desc': 'Features, Stripe, and SMTP for this business',
  'dashboard.orders.title': 'Orders',
  'dashboard.orders.desc': 'View guest checkouts and payment status',
  'dashboard.products.title': 'Products',
  'dashboard.products.desc': 'Manage HVAC products and pricing',
  'dashboard.bundles.title': 'Bundles',
  'dashboard.bundles.desc': 'Manage system packages and optional add-ons',
  'dashboard.brands.title': 'Brands',
  'dashboard.brands.desc': 'Manage catalog brands',
  'dashboard.categories.title': 'Categories',
  'dashboard.categories.desc': 'Two-level category tree',
  'dashboard.filters.title': 'Category Filters',
  'dashboard.filters.desc': 'Assign filters by category',
  'dashboard.specs.title': 'Spec Tags',
  'dashboard.specs.desc': 'Manage product specification tags by category',
  'users.subtitle': 'Admin accounts for this platform.',
  'users.new': 'New user',
  'users.edit': 'Edit user',
  'users.empty': 'No users yet.',
  'users.email': 'Email',
  'users.emailRequired': 'Email is required.',
  'users.emailInvalid': 'Enter a valid email address.',
  'users.password': 'Password',
  'users.passwordMin': 'Password must be at least 8 characters.',
  'users.passwordRequired': 'Password is required.',
  'users.role': 'Role',
  'users.scope': 'Scope',
  'users.business': 'Business',
  'users.selectBusiness': 'Select business',
  'users.loadError': 'Could not load users.',
  'users.saveError': 'Could not save the user.',
  'users.impersonate': 'Login as',
  'users.impersonateError': 'Could not impersonate that user.',
  'users.role.PortalAdmin': 'Portal admin',
  'users.role.BusinessAdmin': 'Business admin',
  'brands.subtitle': 'Brand catalog CRUD',
  'brands.new': 'New brand',
  'brands.edit': 'Edit brand',
  'brands.empty': 'No brands yet.',
  'brands.loadError': 'Could not load brands.',
  'brands.saveError': 'Could not save brand.',
  'brands.deleteError': 'Could not delete brand.',
  'brands.deleteConfirm': 'Delete brand "{name}"?',
  'brands.logo': 'Logo',
  'brands.logoOptional': '(optional)',
  'brands.logoHint': 'Optional. PNG, JPG, WebP, GIF or SVG. If set, it appears on Shop By Brand with the brand name; otherwise the name is shown alone.',
  'brands.chooseLogo': 'Choose logo',
  'brands.removeLogo': 'Remove logo',
  'categories.subtitle': 'Parents and children (max 2 levels)',
  'categories.new': 'New category',
  'categories.edit': 'Edit category',
  'categories.addChild': '+ Child',
  'categories.empty': 'No categories yet.',
  'categories.loadError': 'Could not load categories.',
  'categories.saveError': 'Could not save category.',
  'categories.deleteError': 'Could not delete category.',
  'categories.deleteConfirm': 'Delete category "{name}"?',
  'categories.order': 'Order',
  'categories.saveOrder': 'Save order',
  'categories.moveUp': 'Move up',
  'categories.moveDown': 'Move down',
  'categories.orderError': 'Could not save category order.',
  'categories.image': 'Image',
  'categories.imageOptional': '(optional)',
  'categories.imageHint': 'Optional. PNG, JPG, WebP, GIF or SVG. Shown on category cards on the home page.',
  'categories.chooseImage': 'Choose image',
  'categories.removeImage': 'Remove image',
  'filters.subtitle': 'Define filters and assign them to leaf categories',
  'filters.new': 'New filter',
  'filters.edit': 'Edit filter',
  'filters.leafCategory': 'Child categories',
  'filters.noLeaf': 'No child categories.',
  'filters.assigned': 'Assigned',
  'filters.noneAssigned': 'No filters assigned.',
  'filters.available': 'Available to assign',
  'filters.noneAvailable': 'No filters available.',
  'filters.remove': 'Remove',
  'filters.assign': 'Assign',
  'filters.catalog': 'Filter catalog',
  'filters.valueType': 'Value type',
  'filters.options': 'Options',
  'filters.addOption': 'Add option',
  'filters.optionsHint': 'Define the selectable values. Catalog shows them as multi-select checkboxes.',
  'filters.optionLabel': 'Label',
  'filters.optionValue': 'Value (optional slug)',
  'filters.optionsRequired': 'Add at least one option for Options filters.',
  'filters.saveOrder': 'Save order',
  'filters.moveUp': 'Move up',
  'filters.moveDown': 'Move down',
  'filters.orderError': 'Could not save filter order.',
  'filters.loadCategoriesError': 'Could not load categories.',
  'filters.loadError': 'Could not load filters.',
  'filters.loadCategoryError': 'Could not load category filters.',
  'filters.assignError': 'Could not assign filter.',
  'filters.unassignError': 'Could not remove filter.',
  'filters.unassignConfirmSimple': 'Remove filter "{name}" from this category?',
  'filters.unassignConfirmUsed':
    'Filter "{name}" is in use. Removing it will also delete:\n• {values} allowed category value(s)\n• attribute on {products} product(s)\n• attribute on {bundles} bundle(s)\n\nContinue?',
  'filters.createError': 'Could not create filter.',
  'filters.updateError': 'Could not update filter.',
  'filters.deleteError': 'Could not delete filter.',
  'filters.systemDeleteError': 'System filters cannot be deleted.',
  'filters.deleteConfirm': 'Delete filter "{name}"?',
  'products.subtitle': 'Product catalog CRUD',
  'products.new': 'New product',
  'products.edit': 'Edit product',
  'products.empty': 'No products yet.',
  'products.price': 'Price',
  'products.compareAtPrice': 'Compare at',
  'products.variants': 'Variants',
  'products.variant': 'Variant',
  'products.defaultVariant': 'Default',
  'products.variantsHint': 'One option only (e.g. Size). Add each variant with its value, SKU, price and compare-at.',
  'products.optionName': 'Option name',
  'products.optionNamePlaceholder': 'e.g. Size',
  'products.optionNameRequired': 'Enter an option name before adding variants (e.g. Size).',
  'products.optionValue': 'Value',
  'products.optionValuePlaceholder': 'e.g. 50ml',
  'products.addVariant': 'Add variant',
  'products.addVariantHint': 'Fill all fields, then add. Existing rows stay editable below.',
  'products.duplicateOptionValue': 'That option value already exists.',
  'products.compareAtInvalid': 'Compare-at must be greater than price.',
  'products.variantsIncomplete': 'Fill value, SKU and price for the variant.',
  'products.category': 'Category',
  'products.description': 'Description',
  'products.descriptionHint': 'HTML is supported (e.g. <p>, <ul>, <strong>).',
  'products.loadError': 'Could not load products.',
  'products.saveError': 'Could not save product.',
  'products.deleteError': 'Could not delete product.',
  'products.deleteConfirm': 'Delete product "{name}"?',
  'products.attributes': 'Category filters',
  'products.noAttributes': 'No custom filters assigned to this category.',
  'products.attributesHint': 'Brand and price use the fields above. Other assigned filters appear here.',
  'products.specifications': 'Product specifications',
  'products.specificationsHint': 'Pick an existing tag or type a new one (created automatically for this category).',
  'products.addSpec': 'Add row',
  'products.noSpecs': 'No specifications yet.',
  'products.specTag': 'Tag',
  'products.specValue': 'Value',
  'products.images': 'Images',
  'products.imagesHint': 'Upload one or more images. The first becomes primary.',
  'products.noImages': 'No images uploaded.',
  'products.setPrimary': 'Set primary',
  'products.primary': 'Primary',
  'products.documents': 'Related documents',
  'products.documentsHint': 'Select a file (title is prefilled; you can edit it), then upload.',
  'products.chooseImages': 'Choose images',
  'products.chooseFile': 'Choose file',
  'products.documentTitle': 'Document title',
  'products.uploadDocument': 'Upload',
  'products.selectedFile': 'Selected file',
  'products.noDocuments': 'No documents uploaded.',
  'products.saveBeforeMedia': 'Save the product first to upload images and documents.',
  'products.mediaError': 'Could not update media.',
  'bundles.subtitle': 'System packages with required and optional products',
  'bundles.new': 'New bundle',
  'bundles.edit': 'Edit bundle',
  'bundles.empty': 'No bundles yet.',
  'bundles.loadError': 'Could not load bundles.',
  'bundles.saveError': 'Could not save bundle.',
  'bundles.deleteError': 'Could not delete bundle.',
  'bundles.deleteConfirm': 'Delete bundle "{name}"?',
  'bundles.requiredProductsError': 'Add at least one required product.',
  'bundles.packProducts': 'Pack products',
  'bundles.packProductsHint': 'Required products are always included. Optional products can be added at purchase.',
  'bundles.searchProducts': 'Search products',
  'bundles.searchProductsPlaceholder': 'Name, SKU or model...',
  'bundles.noProductResults': 'No matching active products.',
  'bundles.addRequired': '+ Required',
  'bundles.addOptional': '+ Optional',
  'bundles.required': 'Required',
  'bundles.optional': 'Optional',
  'bundles.noRequired': 'No required products yet.',
  'bundles.noOptional': 'No optional products yet.',
  'bundles.makeOptional': 'Make optional',
  'bundles.makeRequired': 'Make required',
  'specs.subtitle': 'Predefine reusable tags per product category',
  'specs.leafCategory': 'Leaf category',
  'specs.noLeaf': 'No child categories.',
  'specs.catalog': 'Tags for category',
  'specs.new': 'New tag',
  'specs.edit': 'Edit tag',
  'specs.empty': 'No tags for this category.',
  'specs.loadCategoriesError': 'Could not load categories.',
  'specs.loadError': 'Could not load specification tags.',
  'specs.saveError': 'Could not save specification tag.',
  'specs.deleteError': 'Could not delete specification tag.',
  'specs.deleteConfirm': 'Delete tag "{name}"?',
  'specs.saveOrder': 'Save order',
  'specs.moveUp': 'Move up',
  'specs.moveDown': 'Move down',
  'specs.orderError': 'Could not save tag order.',
  'portal.model': 'Model',
  'portal.catalog.brand': 'Brand',
  'portal.catalog.allBrands': 'All brands',
  'portal.catalog.allCategories': 'All categories',
  'portal.product.quantity': 'Quantity',
  'portal.checkout.pdfError': 'Could not download the PDF.',
  'orders.subtitle': 'Guest checkouts and payment status.',
  'orders.empty': 'No orders found.',
  'orders.loadError': 'Could not load orders.',
  'orders.searchPlaceholder': 'Search email, name, phone, order id…',
  'orders.filter': 'Filter',
  'orders.created': 'Created',
  'orders.paid': 'Paid',
  'orders.customer': 'Customer',
  'orders.email': 'Email',
  'orders.total': 'Total',
  'orders.subtotal': 'Subtotal',
  'orders.tax': 'Tax (7%)',
  'orders.lines': 'Lines',
  'orders.view': 'View',
  'orders.detail': 'Order detail',
  'orders.orderId': 'Order #',
  'orders.lineItems': 'Line items',
  'orders.item': 'Item',
  'orders.type': 'Type',
  'orders.price': 'Price',
  'orders.lineTotal': 'Line total',
  'orders.downloadPdf': 'Download PDF',
  'orders.pdf': 'PDF',
  'orders.showing': 'Showing {shown} of {total} orders.',
  'orders.status.Pending': 'Pending',
  'orders.status.Paid': 'Paid',
  'common.close': 'Close'
} as const;

export type TranslationKey = keyof typeof en;
